<template>
    <div class="structure-block-benefit-banner flex justify-center flex-col xl:grid xl:grid-cols-2 py-6 md:justify-center mx-auto md:items-center">
        <div class="grid grid-cols-1 md:grid-cols-3 max-w-3xl items-center">
            <div>
                <component :is="leftComponent" :content="leftSlot" />
            </div>

            <div>
                <component :is="secondLeftComponent" :content="secondLeftSlot" />
            </div>

            <div>
                <component :is="centerLeftComponent" :content="centerLeftSlot" />
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-3 max-w-3xl items-center">
            <div>
                <component :is="centerRightComponent" :content="centerRightSlot" />
            </div>

            <div>
                <component :is="secondRightComponent" :content="secondRightSlot" />
            </div>

            <div>
                <component :is="rightComponent" :content="rightSlot" />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { HblSlot } from '@/utils/types'
import { hblToUpperCamelCase } from '@/utils/helper'

const props = defineProps<{
    content: HblSlot[]
}>()

const leftSlot = computed(() => {
    return props.content.find(item => item.position === 'left')
})

const secondLeftSlot = computed(() => {
    return props.content.find(item => item.position === 'secondLeft')
})

const centerLeftSlot = computed(() => {
    return props.content.find(item => item.position === 'centerLeft')
})

const centerRightSlot = computed(() => {
    return props.content.find(item => item.position === 'centerRight')
})

const secondRightSlot = computed(() => {
    return props.content.find(item => item.position === 'secondRight')
})

const rightSlot = computed(() => {
    return props.content.find(item => item.position === 'right')
})

const leftComponent = computed(() => {
    if (!leftSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(leftSlot.value.type)}`
})

const secondLeftComponent = computed(() => {
    if (!secondLeftSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(secondLeftSlot.value.type)}`
})

const centerLeftComponent = computed(() => {
    if (!centerLeftSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(centerLeftSlot.value.type)}`
})

const centerRightComponent = computed(() => {
    if (!centerRightSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(centerRightSlot.value.type)}`
})

const secondRightComponent = computed(() => {
    if (!secondRightSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(secondRightSlot.value.type)}`
})

const rightComponent = computed(() => {
    if (!rightSlot.value?.type) return null
    return `StructureSlot${hblToUpperCamelCase(rightSlot.value.type)}`
})
</script>
